import { Cd4peApiError } from '@utils/api/cd4pe';
import { StdVcsRepo, StdVcsSource } from '@utils/api/cd4pe/vcs/actions';
import * as vcsAt from '@utils/api/cd4pe/vcs/actionTypes';
import { EDIT_CODE_PROJECT_FORM_ACTION_TYPES } from '@codeDelivery/components/EditCodeProjectForm';
import { EditModuleActions } from './actions';
import * as at from './actionTypes';

export interface EditModuleState {
  sources: StdVcsSource[];
  selectedSource: string;
  repositories: StdVcsRepo[];
  name: string;
  saveModuleSuccess: boolean;
  currentModalClosed: boolean;
  getSourcesLoading: boolean;
  getSourcesError: string | null;
  getReposLoading: boolean;
  getReposError: string | null;
  saveModuleLoading: boolean;
  newModuleSource?: string | null;
  saveModuleError: Cd4peApiError | string | null;
  saveModuleWebhookError: boolean;
}

export const defaultEditModuleState: EditModuleState = {
  sources: [],
  selectedSource: '',
  repositories: [],
  name: '',
  saveModuleSuccess: false,
  currentModalClosed: false,
  getSourcesLoading: false,
  getSourcesError: null,
  getReposLoading: false,
  getReposError: null,
  saveModuleLoading: false,
  newModuleSource: null,
  saveModuleError: null,
  saveModuleWebhookError: false,
};

export const reducer = (
  state: EditModuleState,
  action: EditModuleActions,
): EditModuleState => {
  switch (action.type) {
    case vcsAt.GET_SOURCES_START:
      return {
        ...state,
        getSourcesLoading: true,
      };
    case vcsAt.GET_SOURCES_COMPLETE:
      return {
        ...state,
        getSourcesLoading: false,
        sources: action.payload,
      };
    case vcsAt.GET_SOURCES_ERROR:
      return {
        ...state,
        getSourcesLoading: false,
        getSourcesError: action.payload,
      };
    case vcsAt.GET_REPOS_START:
      return {
        ...state,
        getReposLoading: true,
      };
    case vcsAt.GET_REPOS_COMPLETE:
      return {
        ...state,
        getReposLoading: false,
        repositories: action.payload,
      };
    case vcsAt.GET_REPOS_ERROR:
      return {
        ...state,
        getReposLoading: false,
        getReposError: action.payload,
      };
    case at.EDIT_MODULE_START:
      return {
        ...state,
        saveModuleLoading: true,
        getReposError: null,
        saveModuleError: null,
      };
    case at.EDIT_MODULE_COMPLETE:
      return {
        ...state,
        saveModuleLoading: false,
        saveModuleSuccess: true,
      };
    case at.EDIT_MODULE_ERROR:
      return {
        ...state,
        saveModuleLoading: false,
        saveModuleSuccess: false,
        saveModuleError: action.payload,
      };
    case at.EDIT_MODULE_WEBHOOK_ERROR:
      return {
        ...state,
        saveModuleLoading: false,
        saveModuleSuccess: false,
        saveModuleWebhookError: true,
      };
    case EDIT_CODE_PROJECT_FORM_ACTION_TYPES.SELECTED_SOURCE:
      return {
        ...state,
        selectedSource: action.payload,
        repositories: [],
        name: '',
        saveModuleError: null,
        getReposError: null,
      };
    case EDIT_CODE_PROJECT_FORM_ACTION_TYPES.NAME:
      return {
        ...state,
        name: action.payload,
      };
    default:
      throw new Error();
  }
};
